module.exports = __webpack_public_path__ + "img/63600.40738ca6.jpg";